import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import uuid from 'uuid/v4';

import { PAGE_TYPES, RENDERING_ENVIRONMENTS_FOR_PAGE } from 'app/RenderingEnvironment/const';
import RenderingEnvironment from 'app/RenderingEnvironment/components/RenderingEnvironment';

import SetPageDetails from './SetPageDetails';
import styles from './AddNewPage.css';

const FLASH_EVENT_CATEGORY_OPTIONS = ['All', 'Women', 'Men', 'Kids', 'Home', 'Beauty'];

const newPageWorkflow = {
  setRenderingEnv: 1,
  setPageDetails: 2
};

/**
 * Add New Page
 */
export default class AddNewPage extends Component {
  static propTypes = {
    createNewUnsavedPage: propTypes.func.isRequired,
    cwd: propTypes.string.isRequired,
    isOpen: propTypes.bool.isRequired,
    onAddPageClick: propTypes.func.isRequired,
    setRenderingEnv: propTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      newPageStage: newPageWorkflow.setRenderingEnv,
      renderingEnv: {},
      pageCategory: FLASH_EVENT_CATEGORY_OPTIONS[0],
      pageDate: '',
      pageName: '',
      pageTime: ''
    };

    this.onPageDateInputChange = this.onPageDateInputChange.bind(this);
    this.onPageCategoryInputChange = this.onPageCategoryInputChange.bind(this);
    this.onPageNameInputChange = this.onPageNameInputChange.bind(this);
    this.onPageTimeInputChange = this.onPageTimeInputChange.bind(this);
    this.showSetPageDetails = this.showSetPageDetails.bind(this);
    this.showSetRenderingEnvironment = this.showSetRenderingEnvironment.bind(this);
    this.savePage = this.savePage.bind(this);
    this.modalToggle = this.modalToggle.bind(this);
  }

  /**
   * Update state when page name input changes
   * @param {object} e - event
   */
  onPageNameInputChange(e) {
    this.setState({
      pageName: e.target.value
    });
  }

  /**
   * Update state when page category input changes
   * @param {object} e - event
   */
  onPageCategoryInputChange(e) {
    this.setState({
      pageCategory: e.target.value
    });
  }

  /**
   * Update state when page date input changes
   * @param {object} e - event
   */
  onPageDateInputChange(e) {
    this.setState({
      pageDate: e.target.value
    });
  }

  /**
   * Update state when page date input changes
   * @param {object} e - event
   */
  onPageTimeInputChange(e) {
    this.setState({
      pageTime: e.target.value
    });
  }

  /**
   * show Set Page Name section of Modal
   * @param {object} renderingEnv - containg page type and pagetemplate name
   */
  showSetPageDetails(renderingEnv) {
    this.props.setRenderingEnv(renderingEnv);
    this.setState({
      renderingEnv,
      newPageStage: newPageWorkflow.setPageDetails
    });
  }

  /**
   * show Set Renderinv Environment section of Modal
   */
  showSetRenderingEnvironment() {
    this.setState({ newPageStage: newPageWorkflow.setRenderingEnv });
  }

  /**
   * Save page
   */
  savePage() {
    const { createNewUnsavedPage, cwd } = this.props;
    const { pageCategory, pageDate, pageName, pageTime, renderingEnv } = this.state;
    const id = uuid();
    const isFlashEvent = renderingEnv.pageType === PAGE_TYPES.FLASH_EVENT;
    if (pageName.length) {
      this.modalToggle();
      createNewUnsavedPage({
        isFlashEvent,
        pageCategory,
        pageDate,
        pageName,
        pageTime,
        renderingEnv,
        id,
        cwd
      });
    }
  }

  /**
   * Show or hide the modal
   */
  modalToggle() {
    this.props.onAddPageClick();
  }

  /**
   * Show relevent portions of data in modal
   * @returns {React.Component} portion of workflow
   */
  renderStage() {
    const { newPageStage, renderingEnv } = this.state;

    switch (newPageStage) {
      case newPageWorkflow.setPageDetails:
        return (
          <React.Fragment>
            <SetPageDetails
              flashEventCategoryOptions={FLASH_EVENT_CATEGORY_OPTIONS}
              isFlashEvent={renderingEnv?.pageType === PAGE_TYPES.FLASH_EVENT}
              onCancel={this.showSetRenderingEnvironment}
              onEnter={this.savePage}
              onPageCategoryInputChange={this.onPageCategoryInputChange}
              onPageDateInputChange={this.onPageDateInputChange}
              onPageNameInputChange={this.onPageNameInputChange}
              onPageTimeInputChange={this.onPageTimeInputChange}
            />
          </React.Fragment>
        );
      default:
        return (
          <RenderingEnvironment
            onCancel={this.modalToggle}
            onEnter={this.showSetPageDetails}
            environmentToRender={RENDERING_ENVIRONMENTS_FOR_PAGE}
          />
        );
    }
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.modalToggle}>
        <ModalBody className={styles.modal}>{this.renderStage()}</ModalBody>
      </Modal>
    );
  }
}
